export default {
	type: 'object',
	properties: {
		recordId: { type: 'string' },
		id: { type: 'string' },
	},
	additionalProperties: false,
}
